import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchIdibuIframeHtml } from "../../Redux/ActionCreators/idibuAction";
import "./idibuPostModal.scss";

/**
 * Job tab panel: loads authenticated HTML that auto-POSTs into idibu CRM iframe.
 */
function IdibuPostTab() {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [frameUrl, setFrameUrl] = useState("");

  useEffect(() => {
    if (!jobId) return undefined;

    let cancelled = false;
    let objectUrl = "";

    (async () => {
      setLoading(true);
      setError("");
      setFrameUrl("");
      const result = await dispatch(fetchIdibuIframeHtml(jobId));
      if (cancelled) return;
      if (result?.success && result.html) {
        objectUrl = URL.createObjectURL(
          new Blob([result.html], { type: "text/html" })
        );
        setFrameUrl(objectUrl);
      } else {
        setError(result?.message || "Failed to open Idibu posting");
      }
      setLoading(false);
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [jobId, dispatch]);

  useEffect(() => {
    return () => {
      if (frameUrl) URL.revokeObjectURL(frameUrl);
    };
  }, [frameUrl]);

  const retry = async () => {
    if (!jobId) return;
    setLoading(true);
    setError("");
    setFrameUrl("");
    const result = await dispatch(fetchIdibuIframeHtml(jobId));
    if (result?.success && result.html) {
      const objectUrl = URL.createObjectURL(
        new Blob([result.html], { type: "text/html" })
      );
      setFrameUrl(objectUrl);
    } else {
      setError(result?.message || "Failed to open Idibu posting");
    }
    setLoading(false);
  };

  return (
    <div className="idibu-post-tab">
      <div className="idibu-post-tab-header">
        <div>
          <h3>Post to Job Boards</h3>
          <p>Select boards and publish this job inside Idibu.</p>
        </div>
        {error ? (
          <button type="button" className="idibu-btn-secondary" onClick={retry}>
            Retry
          </button>
        ) : null}
      </div>
      <div className="idibu-post-tab-body">
        {loading ? (
          <div className="idibu-modal-state">
            <div className="spinner-border" role="status" style={{ color: "#F75891" }}>
              <span className="visually-hidden">Loading…</span>
            </div>
            <p>Opening Idibu…</p>
          </div>
        ) : null}
        {error ? (
          <div className="idibu-modal-state idibu-modal-error">
            <p>{error}</p>
          </div>
        ) : null}
        {!loading && !error && frameUrl ? (
          <iframe title="Idibu posting" className="idibu-frame" src={frameUrl} />
        ) : null}
      </div>
    </div>
  );
}

export default IdibuPostTab;
